import { createFileRoute } from "@tanstack/react-router"

import { IntakePanel } from "@/pages/IntakePanel"

export const Route = createFileRoute("/operations/intake")({
  component: IntakePanel,
})
